import hyperdom from 'hyperdom'
import * as gtmDataLayer from '../../../../analytics/gtm/dataLayer.js'

export default class BasePaymentMethod {
  constructor (payment) {
    this.payment = payment
  }

  onadd () {
    gtmDataLayer.activateOptimize()
  }

  onupdate () {
    gtmDataLayer.activateOptimize()
  }

  feeAmount () {
    return 0
  }

  validate () {
  }

  failed () {
  }

  declined () {
  }

  success () {
  }

  render () {
    return <div class='o-accent-box'>
      { this.payment.renderPaymentMethodSelection({noDetails: true}) }
    </div>
  }

  renderTermsAndConditions () {
    return this.payment.renderTermsAndConditions()
  }

  renderReassurance () {
  }

  renderPaymentSummary () {
    return [
      this.payment.renderPaymentAmount(),
      <button type='submit' class='btn-primary pay-now-btn'>Book Now</button>,
    ]
  }

  renderPaymentOption () {
    return this.displayName
  }
}

